import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import { useAppTranslate } from '../../../core/hooks';
import { DashboardCard } from '../DashboardCard/DashboardCard';
import { DashboardContactTitle } from '../DashboardContactTitle/DashboardContactTitle';

export const DashboardContact: FunctionComponent = () => {
  const translate = useAppTranslate();

  return <DashboardCard title={translate('cards.contact.title')}>
    <Box sx={{ minWidth: '330px' }}>
      <Box sx={{ display: 'flex', gap: 5 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <DashboardContactTitle title={translate('cards.contact.phone')} />
          <Box sx={{ mb: 2 }}>22 340 66 60</Box>
          <DashboardContactTitle title={translate('cards.contact.email')} />
          <Box>
            <a href={'mailto:bok@exatel.pl'} target={'_blank'} rel="noreferrer">bok@exatel.pl</a>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <DashboardContactTitle title={translate('cards.contact.contact')} />
          <Box>EXATEL SA</Box>
          <Box>ul. Perkuna 47</Box>
          <Box>04-164 Warszawa</Box>
          <Box>
            <a href={'mailto:kontakt@exatel.pl'}>kontakt@exatel.pl</a>
          </Box>
        </Box>
      </Box>
    </Box>
  </DashboardCard>;
}